import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography, FormControl, Paper } from '@mui/material';
import moment from 'moment';
import { fetchEnvironmentImpact } from '../../../actions/environmentImpact';
import MyEnviroImpact from '../../rescuerDashboard/rescuerDashboardDesktop/myFrus/Components/MyEnviroImpact';
import DateAndGranularityPicker, { dateRangeOptionsList }
from '../../../components/DateAndGranularityPicker/DateAndGranularityPicker';

const formatDate = (date) => moment(date).format('YYYY-MM-DD');

// filters: what the impact is of, sent to GET /environment_impact. the site (siteId) by default, or e.g. a food donor
// location ({ food_donor_id }) or an umbrella food donor ({ donor_id }) on the food donor dashboards. filterControls: an
// extra control shown next to the date range (e.g. the umbrella's food donor picker). showRescuerEffort: the hours and
// miles tiles, which food donor dashboards leave out. showTitle: off where the tab already says it
const SCDashboardEnvironmentImpact = ({
  siteId,
  filters = null,
  filterControls = null,
  defaultDateRange = dateRangeOptionsList.thisQTD,
  showRescuerEffort = true,
  showTitle = true,
}) => {
  const dispatch = useDispatch();
  const environmentImpact = useSelector((state) => state.entities.environmentImpact);
  const [dateRange, setDateRange] = useState(defaultDateRange.range);
  const query = filters || { sites_ids: siteId };
  const queryKey = JSON.stringify(query);

  const handleDateRangeChange = ({ dateRange: newDateRange }) => setDateRange(newDateRange || null);

  // refetch on a new date range and on new filters, keeping the chosen date range
  useEffect(() => {
    if (dateRange) {
      dispatch(fetchEnvironmentImpact(query, formatDate(dateRange.startDate), formatDate(dateRange.endDate)));
    } else {
      dispatch(fetchEnvironmentImpact(query));
    }
  }, [dispatch, queryKey, dateRange && formatDate(dateRange.startDate), dateRange && formatDate(dateRange.endDate)]);

  return (
    <Box>
      {showTitle && (
        <Box mb={2}>
          <Typography variant="h6" color="textSecondary">
            Environmental Impact
          </Typography>
        </Box>
      )}

      <Paper sx={{ margin: '8px auto', padding: 2 }}>
        <Box display="flex" flexWrap="wrap" alignItems="center" gap={2}>
          {filterControls}
          <FormControl variant="standard" component="fieldset">
            <DateAndGranularityPicker
              showAllDateRange
              defaultDateRange={defaultDateRange.value}
              dateRangeOptions={{
                last7Days: dateRangeOptionsList.last7Days,
                last30Days: dateRangeOptionsList.last30Days,
                last90Days: dateRangeOptionsList.last90Days,
                thisMTD: dateRangeOptionsList.thisMTD,
                thisQTD: dateRangeOptionsList.thisQTD,
                thisYTD: dateRangeOptionsList.thisYTD,
              }}
              customDateRangeOptions={{ maxDate: new Date() }}
              showCustomDateRange
              showGranularity={false}
              isDisabled={environmentImpact.inflight}
              onChange={handleDateRangeChange}
            />
          </FormControl>
        </Box>
      </Paper>

      <Box display="flex" mt={2}>
        <MyEnviroImpact
          isLoading={environmentImpact.inflight}
          environmentImpact={environmentImpact.all}
          showRescuerEffort={showRescuerEffort}
        />
      </Box>
    </Box>
  );
};

export default SCDashboardEnvironmentImpact;
